// cryptoHelper.js
const PUBLIC_KEY_PEM = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArQRh4JJ3a4PrVPJCoBJ/
j2cCybMyDDPurCLxoVpM1aj0oxLy2JUe51n2gOxn9IuK9uihA8uMngvv3A8cnmIr
JO0Rs0NnjHy4a3bC0NB8DslrZ+p5HYPsiOv2lSPed5vm6wZ/qwombBbRX8SnERL/
O0MwRWlB9J3RrnM+DqUeMGoFGbte4qmn1uhOZV86HhCmX7RZJAPXUpWOBHqp+NrL
ORr2OkB8eyoeIUlitKJgcDqiDmmQV6H5+VGcZoeYX3L4R6uc9iP02n/0QE0JeJLS
DOLVBxbU9YXEbEFklhsiVSJK0PIsvm3vhMvSus3C3jHqOZxURP3VCbC7Y3pt5l1t
oQIDAQAB
-----END PUBLIC KEY-----
`.trim();

function pemToArrayBuffer(pem) {
  const b64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s+/g, "");
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

// aproximăm Python `encode("utf-16")` cu UTF-16LE
function encodeUtf16LE(str) {
  const buf = new ArrayBuffer(str.length * 2);
  const view = new DataView(buf);
  for (let i = 0; i < str.length; i++) {
    view.setUint16(i * 2, str.charCodeAt(i), true);
  }
  return new Uint8Array(buf);
}

export async function encryptPassword(password) {
  const keyData = pemToArrayBuffer(PUBLIC_KEY_PEM);
  const key = await window.crypto.subtle.importKey(
    "spki",
    keyData,
    { name: "RSA-OAEP", hash: "SHA-1" },
    false,
    ["encrypt"]
  );

  const data = encodeUtf16LE(password);
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    key,
    data
  );

  // ArrayBuffer -> Base64 (ca în backend)
  const bytes = new Uint8Array(encrypted);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
